var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 128,
    viewBox: "0 0 92 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(-974 -300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(446 -271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    transform: "translate(528 592)",
    fill: "#fff",
    stroke: "#cecece",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "<",
    transform: "translate(553 673)",
    fill: "#888",
    fontSize: 80,
    fontFamily: "Noteworthy-Bold, Noteworthy",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&lt;"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expandIcon.6f893aa8bf6207a0eb267f07cb51cc4b.svg";
export { ForwardRef as ReactComponent };